
const digest = 'f3a25d64b01f84a25ebb057d912671d73d1960d7af50b5d375ad07bea5f8c452';
const classes = {"wrapper":"_wrapper_cer21_1","title":"_title_cer21_8","content":"_content_cer21_17","subtitle":"_subtitle_cer21_27","text":"_text_cer21_32","button":"_button_cer21_36"};
const css = `._wrapper_cer21_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 7.5px;
}
._wrapper_cer21_1 ._title_cer21_8 {
  font-size: 14px;
  color: #3e3f42;
  font-weight: 400;
  padding: 17px 24px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  margin-bottom: 0;
}
._wrapper_cer21_1 ._content_cer21_17 {
  padding: 20px;
  border: 1px solid #eaedf3;
  height: 100%;
  background: #ffffff;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_cer21_1 ._content_cer21_17 ._subtitle_cer21_27 {
  font-weight: 500;
  font-size: 16px;
  color: #1665d8;
}
._wrapper_cer21_1 ._content_cer21_17 ._text_cer21_32 {
  font-size: 14px;
  color: #000000;
}
._wrapper_cer21_1 ._content_cer21_17 ._button_cer21_36 {
  width: fit-content;
  margin-bottom: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  